<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/F6uRJz/tc-custom/9781452124711.jpg?1705202000342" alt="This image is the cover for the book Fondue"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fondue
      </h1>
      <p class="bookDescription body article font2">
        <b>Stir up some fun at your next gathering with this delightful collection of fondue recipes, featuring cheese fondue, entrée fondues, and dessert fondues.</b><br/><br/>Whether served at festive gatherings or intimate dinners, fondue is a party dish guaranteed to deliver fabulous flavors and fun. Bestselling author Lou Seibert Pappas offers recipes that are easy to make and fabulously delicious. Traditionalists will revel in cheese fondues such as Bagna Cauda and Tuscan Cheese Fondue. Entrée options include Filet Mignon and Shrimp Fondue or Beach Lover’s Fish Pot. Best of all, the host can enjoy the time spent with family and friends, as the cooking is done right at the table. So, without ado, get ready to dip, swirl, and delight in <i>Fondue</i>!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lou Seibert Pappas, Alison Miksch
      </h2>
      
      <p class="authorDescription body article">Lou Seibert Pappas is the author of more than 50 books, including Pancakes & Waffles, Biscotti, The Christmas Cookie Book, and Crêpes. She lives in Palo Alto, California.Alison Miksch's photographs have appeared in The New Tea Book, Luscious Lemon Desserts, and Quick & Easy Thai.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0fbefc86